module.exports = __webpack_public_path__ + "img/video.27bee748.png";